/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-summary-label': 'Shrnout',
  'copy-content-link-label': 'Kopírovat odkaz',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Začněte psát, abyste vyhledali štítek',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Vše',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrovat vyhledávání podle produktu',
  'dynamic-cards-search-page.atlas.for': 's termínem',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalendář',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Připojit se ke schůzce',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Odkaz na schůzku',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Připojit se ke schůzce',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Minulé události',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Opakující se událost',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Opakující se',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Nadcházející události',
  'dynamic-cards-search-page.compass.owner-name': 'Vlastník: {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Úroveň {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Najít obsah',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Vybráno',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Navrhované',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Vybráno',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Navrhované',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Najít lidi',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Vybráno',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Najít štítky',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Najít prostory',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Chcete-li zobrazit chybějící výsledky, připojte svůj účet.',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Správce přidal produkt {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} je nyní k dispozici!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Datum Od musí být před datem Do.',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'Datum Od nesmí být v budoucnosti.',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'Datum Do nesmí být v budoucnosti.',
  'dynamic-cards-search-page.date.filter.last.month': 'Posledních 30 dní',
  'dynamic-cards-search-page.date.filter.last.week': 'Posledních 7 dní',
  'dynamic-cards-search-page.date.filter.last.year': 'Poslední rok',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Vygenerovat odpověď',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Nedávné',
  'dynamic-cards-search-page.error_primary': 'Při vyhledávání se vyskytly problémy',
  'dynamic-cards-search-page.error_secondary':
    'Možná šlo jen o náhodnou chybku. Nejlepší bude <btn>zkusit to znovu</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Externí lidé kanálu #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Vymazat filtr',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Kdykoli',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Posledních 30 dní',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Posledních 7 dní',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Poslední rok',
  'dynamic-cards-search-page.filter.last.updated.today': 'Dnes',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Včera',
  'dynamic-cards-search-page.filter.type.answer': 'Odpovědi',
  'dynamic-cards-search-page.filter.type.attachment': 'Přílohy',
  'dynamic-cards-search-page.filter.type.blogpost': 'Příspěvky na blogu',
  'dynamic-cards-search-page.filter.type.branch': 'Větve',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalendáře',
  'dynamic-cards-search-page.filter.type.comment': 'Komentáře',
  'dynamic-cards-search-page.filter.type.commit': 'Commity',
  'dynamic-cards-search-page.filter.type.component': 'Komponenty',
  'dynamic-cards-search-page.filter.type.conversation': 'Konverzace',
  'dynamic-cards-search-page.filter.type.database': 'Databáze',
  'dynamic-cards-search-page.filter.type.design': 'Designy',
  'dynamic-cards-search-page.filter.type.documents': 'Dokumenty',
  'dynamic-cards-search-page.filter.type.issue': 'Požadavky',
  'dynamic-cards-search-page.filter.type.message': 'Zprávy',
  'dynamic-cards-search-page.filter.type.page': 'Stránky',
  'dynamic-cards-search-page.filter.type.placeholder': 'Najít typ',
  'dynamic-cards-search-page.filter.type.presentation': 'Prezentace',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull requesty',
  'dynamic-cards-search-page.filter.type.question': 'Otázky',
  'dynamic-cards-search-page.filter.type.repository': 'Repozitáře',
  'dynamic-cards-search-page.filter.type.space': 'Prostory',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Kalendáře prostoru',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Tabulky',
  'dynamic-cards-search-page.filter.type.video': 'Videa',
  'dynamic-cards-search-page.filter.type.web-page': 'Webové stránky',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Tabule',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Zrušit vše',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filtr',
  'dynamic-cards-search-page.filters.names.content': 'Obsah pod:',
  'dynamic-cards-search-page.filters.names.contributor': 'Přispěvatel',
  'dynamic-cards-search-page.filters.names.labels': 'Štítek',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Shoda názvu',
  'dynamic-cards-search-page.github-branch-result.label': 'Větev',
  'dynamic-cards-search-page.github-commit-result.label': 'Potvrdit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Stav',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Vyhledejte cokoli.',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Najít projekty',
  'dynamic-cards-search-page.landing_primary': 'Začínáme s filtry pro dynamické karty',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Dokumenty',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Prezentace',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Tabulky',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Vašemu vyhledávání neodpovídají žádné výsledky',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Vypadá to, že jste použili nějaké filtry. Můžete je zkusit vymazat.',
  'dynamic-cards-search-page.nouns.goal': 'Cíl',
  'dynamic-cards-search-page.nouns.goals': 'Cíle',
  'dynamic-cards-search-page.nouns.tag': 'Štítek',
  'dynamic-cards-search-page.nouns.tags': 'Štítky',
  'dynamic-cards-search-page.number_of_results': 'Zobrazené výsledky: {numberOfResults,number}/{totalCount,number}',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Autorizace pro produkt {product} se nezdařila.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Autorizace pro produkt {product} byla úspěšná.',
  'dynamic-cards-search-page.oauth-message-connect': 'Připojit',
  'dynamic-cards-search-page.products.custom-website': 'Webová stránka',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Seřadit podle vytvoření (od nejnovějších)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Vytvoření (od nejnovějších)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Aktualizace (od nejnovější)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Seřadit podle aktualizace (od nejnovější)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Změnit řazení seznamu',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Další',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Chcete-li získat relevantnější výsledky vyhledávání, filtrujte podle produktu.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading':
    'Vyhledávejte napříč všemi pracovními prostory vaší společnosti',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'V závislosti na produktu, podle kterého filtrujete, se tyto možnosti mění, abyste vždy našli konkrétní výsledky.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Najděte přesně to, co hledáte',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Příloha',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Připojeno {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Zvuk',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Obrázek',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Aktualizováno: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Soukromý kanál',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Ikona Odebrat nedávné vyhledávání',
  'dynamic-cards-search-page.search-result.repository-label': 'Repozitář',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Skupinová zpráva s externími uživateli} =2 {{name1} a {name2}} =3 {{name1}, {name2} a {name3}} =4 {{name1}, {name2}, {name3} a další ({overflowContributorCount})} one {{name1}} few {{name1}, {name2}, {name3} a {overflowContributorCount} další} many {{name1}, {name2}, {name3} a {overflowContributorCount} dalšího} other {{name1}, {name2}, {name3} a {overflowContributorCount} dalších}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'neznamy-kanal',
  'dynamic-cards-search-page.search_result_type_answer': 'Odpověď',
  'dynamic-cards-search-page.search_result_type_card': 'Karta',
  'dynamic-cards-search-page.search_result_type_component': 'Složka',
  'dynamic-cards-search-page.search_result_type_document': 'Dokument',
  'dynamic-cards-search-page.search_result_type_embed': 'Chytrý odkaz',
  'dynamic-cards-search-page.search_result_type_folder': 'Složka',
  'dynamic-cards-search-page.search_result_type_presentation': 'Prezentace',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull Request',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Dokument SharePoint',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Kalendář prostoru',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Tabulka',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Nerozpoznané',
  'dynamic-cards-search-page.search_result_type_work_item': 'Požadavek',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Správce přidal produkt <strong>{product}!</strong>{br} Připojte svůj účet, abyste viděli chybějící výsledky, včetně dokumentů, ke kterým máte přístup pouze vy.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} je nyní k dispozici!</strong>{br} Připojte svůj účet, abyste viděli chybějící výsledky, včetně dokumentů, ke kterým máte přístup pouze vy.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autorizovat',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail':
    'Autorizace pro produkt {product} se nezdařila.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success':
    'Autorizace pro produkt {product} byla úspěšná.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrovat podle všech aplikací',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrovat podle dalších aplikací',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archivováno',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'V ohrožení',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Zrušeno',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Dokončeno',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Na špatné cestě',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Na dobré cestě',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Pozastaveno',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Čekající na vyřízení',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} kapitola v tomto videu} few {{chapterCount,number} kapitoly v tomto videu} many {{chapterCount,number} kapitoly v tomto videu} other {{chapterCount,number} kapitol v tomto videu}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'ikona videa',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniatura videa',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'je přiřazen(a)',
  'dynamic-cards-search-page.work-item-creator.created': 'vytvořeno',
  'dynamic-cards-search-page.work-item-status.for': 's termínem',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Požadavek',
  'initialsAvatar.label': 'Avatar s iniciály',
  'personAvatar.label': 'Avatar osoby',
  'search-page.results.private-result-label': 'Soukromé',
  'search-page.results.private-result-tooltip': 'Viditelné pouze pro vás',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} člen} few {{memberCount,number} členové} many {{memberCount,number} člena} other {{memberCount,number} členů}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanál',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanál',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} člen} few {{count,number} členové} many {{count,number} člena} other {{count,number} členů}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Naposledy aktivní {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'neznamy-kanal',
  'search-page.results.product-results.third-party.external-people-label': 'Externí lidé',
  'search-page.results.product-results.third-party.external-person-label': 'Externí osoba',
  'search-page.results.product-results.third-party.last-active': 'Naposledy aktivní {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Zpráva',
  'search-page.results.product-results.third-party.no-contributors-label': 'Externí lidé v kanálu #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} v soukromé konverzaci',
  'search-page.results.product-results.third-party.thread-type-label': 'Vlákno',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} v kanálu #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} a {remainingContributorsCount} další} few {{title} a {remainingContributorsCount} další} many {{title} a {remainingContributorsCount} dalšího} other {{title} a {remainingContributorsCount} dalších}}',
  'search-page.results.restricted-result-label': 'Omezeno',
  'search-page.results.restricted-result-tooltip': 'Viditelné pouze pro konkrétní lidi',
  'search-page.show-more-breadcrumbs-button-label': 'Zobrazit podrobnější drobečkovou navigaci',
  'search-page.verified-icon-label': 'Ověřeno',
  'search-page.verified-icon-tooltip-message': 'Tato stránka byla ověřena vlastníkem nebo správcem.',
  'search-result.result.count':
    '{count, plural, one {Zobrazuje se {count} výsledek} few {Zobrazují se {count} výsledky} many {Zobrazuje se {count} výsledku} other {Zobrazuje se {count} výsledků}}',
  'search-result.user-mention.external-person': 'Externí osoba',
};
